import { strings } from '@constants/strings';

export const RETURN_ORDERS_COLUMNS = (t, status = {}) => [
  {
    title: t(strings.order_id),
    dataIndex: strings.order_id,
    width: 120,
  },
  {
    title: t(strings.item_details),
    dataIndex: strings.item_details,
    width: 400,
  },
  {
    title: t(strings.buyer),
    dataIndex: strings.buyer,
    width: 250,
  },
  {
    title: t(strings.total_refund),
    dataIndex: strings.total_refund,
    width: 140,
  },
  {
    title: t(strings.return_reason),
    dataIndex: strings.return_reason,
    width: 220,
  },
  ['rejected', 'all'].includes(status?.slug) && {
    title: t(strings.rejection_reason),
    dataIndex: strings.rejection_reason,
    width: 220,
  },
  {
    title: t(strings.delivered_on),
    dataIndex: strings.delivered_on,
    width: 150,
  },
  {
    title: t(strings.status),
    dataIndex: strings.status,
    width: 120,
  },
  {
    title: strings.actions,
    dataIndex: strings.actions,
    width: 140,
    fixed: 'right',
  },
];

export const RETURN_ORDERS_FILTERS_LIST = ({ dispositions }) => [
  {
    type: 'input',
    key: 'f[order_id]',
    placeholder: 'Order ID',
    chipDisplayName: 'Order ID',
    inputType: 'number',
  },
  {
    type: 'input',
    key: 's[return_line_items.name]',
    placeholder: 'Product Name',
    chipDisplayName: 'Product Name',
  },
  {
    type: 'input',
    key: 's[shipping_address.name]',
    placeholder: 'Buyer Name',
    chipDisplayName: 'Buyer Name',
    // isAdvancedFilter: true,
    // label: 'Buyer Name',
  },
  {
    type: 'input',
    key: 'f[return_line_items.id]',
    placeholder: 'Product ID',
    chipDisplayName: 'Product ID',
    inputType: 'number',
    // isAdvancedFilter: true,
    // label: 'Product ID',
  },
  // {
  //   type: 'date',
  //   key: 'order_delivered_at',
  //   placeholder: 'Delivered on',
  //   chipDisplayName: 'Delivered on',
  //   showRangePreset: true,
  //   disableFutureDates: true,
  //   isAdvancedFilter: true,
  //   label: 'Delivered on',
  // },
];
